import { IframeModal } from '../iframe-modal';
import React from 'react';
import { getAppPackagePickerUrl } from '../upgrade-app-button/get-app-package-picker-url';
import { useSiteContext } from '@wix/app-market-core';

export interface UpgradeModalProps {
  app: {
    id: string;
    externalPricingPageUrl?: string;
  };
  isOpen: boolean;
  onClose: () => void;
}

export const UpgradeModal = ({ app, isOpen, onClose }: UpgradeModalProps) => {
  const { metaSiteId } = useSiteContext();

  const appPackagePickerUrl = getAppPackagePickerUrl({
    appId: app.id,
    metaSiteId: metaSiteId as string,
    isModalEnabled: true,
  });
  return (
    <IframeModal
      isOpen={isOpen}
      onClose={onClose}
      url={appPackagePickerUrl}
      title="Upgrade App"
    />
  );
};
